import React from 'react';

// i18n
import { withTranslation } from 'react-i18next';

export class PostPrivacySelector extends React.PureComponent {
  render() {
    const {
      value, t, onChange, style = {}
    } = this.props;
    return (
      <label className='br-field' style={style}>
        <span className='br-field__label'>{t('WhoCanSeeThis')}</span>
        <select
          className='br-field__input'
          value={value ?? 0}
          onChange={event => onChange(event, {value: Number(event.target.value)})}
        >
          <option value={0}>{t('Readers')}</option>
          <option value={1}>{t('ReadersAndFollowers')}</option>
        </select>
      </label>
    );
  }
}

export default withTranslation()(PostPrivacySelector);
